import { EXPERIMENTS, FEATURE_FLAGS } from '@/lib/consts'

export const APP_DOMAIN = 'provider'

export const SUBJECT_TYPES = {
  BUSINESS_ID: 'business_id',
  FINGERPRINT: 'fingerprint',
}

export const FLAG_TYPES = {
  BOOL: 'bool',
  STRING: 'string',
  INTEGER: 'integer',
}

export const EppoFeatureFlags = {
  [FEATURE_FLAGS.Maintenance_Mode]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: 'disabled',
  },
  // PxCalendar - firestore integration
  [FEATURE_FLAGS.Feature_ProviderFirestore]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_CalendarFirestoreIntegration]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Fix_CalendarFirestoreResyncVisibility]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  // end PxCalendar - firestore integration

  // PxCalendar - AI Receptionist
  [FEATURE_FLAGS.Feature_AiReceptionist]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_AirOnboardingPhoneProvisioning]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  // end PxCalendar - AI Receptionist

  [FEATURE_FLAGS.Feature_BoostAppointmentBlockClientDeleting]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_QuickCardEntryOnCheckout]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: true,
  },

  [FEATURE_FLAGS.Feature_NSPFixedPrize]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_IterableEmbeddedMessaging]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_SalesforceInAppChat]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_InTouchChat]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Logging_Booksy_Unresponsive_Message]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_BoostLandingPage]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_PublicBusinessEmail]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_RegistrationGooglePlacesV3]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_EffortlessKYCAfterEkranZBaba]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Refactor_CustomConsentsKycMicroservice]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ForceConfirmBillingInvoiceDataFlag]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Fix_SubscriptionStripePaymentIntentStatusCheck]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_PeakHours]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.PortfolioInstagram]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_StorePermissions]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_NewInvoicingProcessIE]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_NethoneEnabled]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BarbersShareProfileAfterInvite]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BooksyPayOnboardingRefunds]: { // TODO: remove this flag after the new onboarding is fully deployed (see: PN-1037)
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BooksyPayCancellationFeeWindowUnified]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_RequestRefundPOSv2]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_WebinarInfobox]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.LoyaltyProgram]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ReferAFriend]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ShowSettingsReferralBanner]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_VisibilityPromotionMVP]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_PlatformFee]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_PriceTiers]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_SettingsGooglePlacesV3]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_GoogleAddressManualFallback]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_VisibilityPromotionMVPStats]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ShowBadgeNewOnLoyaltyProgram]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_UseNewTransactionDetailsGet]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_TurnTrackerCheckInMode]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_TurnTracker]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_SwitchBoostToVisibilityFrontend]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_Ecommerce]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_Ecommerce_Modal]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_Ecommerce_Holiday_Modal]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BlackFridayBanner]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ValentinesDayBanner]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BooksyWrapped]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ProductSuggestionsModal]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BusinessPhoneVerificationFlag]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_WaitlistEnhancement]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_WaitlistNewView]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BPOnboardingRedesign]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_AppointmentPaymentDetailsFromBasket]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_InspirationPhotoApptDetails]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BooksyMedFamilyAppointmentButton]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BooksyMedFamilyV2RelationsFlag]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_AllowPaymentsForTrialBusiness]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_LockTrialMessageBlastTemplates]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_AccountDeletionViews]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_SMSMarketingConsentUS]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_TaxIdFieldKYCOnboarding]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ShowNSPSettingsCardVerificationInfo]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_FrontdeskGoogleMaps]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_GoogleReviewsBadge]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Verifactu_due_invoicing_changes]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_StandaloneTipNotificationToggle]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_TippingModalCounterDate]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: '',
  },
  [FEATURE_FLAGS.Feature_BoostScore]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
}

export const EppoExperiments = {
  [EXPERIMENTS.Experiment_ChurnPauseButton]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ShareLoyaltyProgram]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_AAtestMRS]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_BooksyPayActivationScreen]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_OnboardingKYC]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_OnboardingKYCInPoland]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_SubscriptionKYCInPoland]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_SMSMarketingConsentUS]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_PromoteDepositsOverCFV2]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ShareBroaderBeautyProfile]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_GoogleAddressRerun]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_CreateClientGroup]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_GoogleReviewsImportProfileTab]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_NailsServiceOnboarding]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_RegistrationServicesImages]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_AirLiteOnboarding]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_NewSubAndBillingEntryPoint]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_BooksyAssistantChat]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ProfileSubscriptionStatusBadge]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
}
